import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke", "stroke-width"]


export default /*@__PURE__*/_defineComponent({
  __name: 'PencilSvg',
  props: {
  width: {
    type: [String, Number],
    default: 12,
  },
  height: {
    type: [String, Number],
    default: 12,
  },
  stroke: {
    type: String,
    default: 'currentColor',
  },
  strokeWidth: {
    type: [String, Number],
    default: '0.740741',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    fill: "none"
  }, _ctx.$attrs, {
    width: __props.width,
    height: __props.width
  }), [
    _createElementVNode("path", {
      d: "M11 2.85185L9.14815 1L1.74074 8.40741L1 11L3.59259 10.2593L11 2.85185ZM7.66667 2.48148L9.51852 4.33333L7.66667 2.48148ZM1.74074 8.40741L3.59259 10.2593L1.74074 8.40741Z",
      stroke: __props.stroke,
      "stroke-width": __props.strokeWidth,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})